enum ETagType {
  PROFICIENT,
}

export { ETagType };
